<template>
    <div class="form-group" :class="{'is-invalid': errors.has(`${name}`)}">
        <required v-if="label" /> <label v-if="label">{{label}}</label>
        <select :name="name" v-validate="{required: true}" v-model="model" :disabled="disabled" class="form-control">
            <option :value="null">{{$t('words.select')}}</option>
            <option v-for="(item, i) in origens" :value="item.id" v-show="!boleto || boleto && item.bc_codigo" :key="i">{{item.bc_nome}}</option>
        </select>
        <div class="invalid-feedback help-block error">{{errors.first(`${name}`)}}</div>
    </div>
</template>

<script>
    export default {
        inject: ['$validator'],
        props: {
            objectId: {},
            type: String, // C - caixa, B - banco, Default - todos.
            label: String,
            name: String,
            disabled: Boolean,
            boleto: Boolean
        },
        computed: {
            model: {
                get: function () {
                    return this.objectId;
                },
                set: function (val) {
                    this.$emit('setId', val);
                }
            },
            origens() {
                if (!this.type) {
                    return this.caixas.concat(this.bancos);
                };
                switch (this.type.toUpperCase()) {
                    case 'C':
                        return this.caixas;
                    case 'B':
                        return this.bancos;
                    default:
                        return this.caixas.concat(this.bancos);
                }
            },
            bancos() {
                return this.$store.state.banco.select;
            },
            caixas() {
                return this.$store.state.caixa.select;
            },
        }
    };
</script>